export default [
  {
    path: '/attendance-absence-notifications',
    name: 'attendance-absence-notification',
    meta: { requiresAuth: true },
    component: () => import('@/pages/attendance-absence-notification/index.vue')
  }
]
